// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"6f27f876","223":"f476483d","358":"2e75beda","390":"4f9773ff","453":"5c7a3aed","474":"30e184db","494":"03ba5027","503":"0e8809cc","626":"9e0036f7","631":"02e093fa","790":"6f956d27","795":"4d03cf0c","824":"ecc9eb61","844":"94401c49","953":"74a03644"}[chunkId] + ".chunk.js";
};